export default __webpack_public_path__ + "static/media/vehicle.521adf8c.svg";